// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"BasicHeader_subtitle___iRsD","container":"BasicHeader_container__Eo8_u","title":"BasicHeader_title__s2hwH"};